import { useSafeOptimizelyFeature } from '@chegg/optimizely-sdk';
import { useAppSelector } from "../../store/hooks";
export var useIsOpenPass = function useIsOpenPass() {
  var countryCode = useAppSelector(function (state) {
    return state.country;
  });
  var _useSafeOptimizelyFea = useSafeOptimizelyFeature('_oneauth_openpass', undefined, {
      overrideAttributes: {
        FUNNEL_country: countryCode
      }
    }),
    isEnabled = _useSafeOptimizelyFea.isEnabled,
    clientReady = _useSafeOptimizelyFea.clientReady;
  return {
    isEnabled: isEnabled,
    clientReady: clientReady
  };
};